// extracted by mini-css-extract-plugin
module.exports = {"ProductLabelsList":"ProductLabel_ProductLabelsList__2wi-5","ProductLabelsListItem":"ProductLabel_ProductLabelsListItem__1xP1Q"};